import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=67ce791d&scoped=true&"
import script from "./Exercise.vue?vue&type=script&lang=ts&"
export * from "./Exercise.vue?vue&type=script&lang=ts&"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=67ce791d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce791d",
  null
  
)

export default component.exports